export default "__VITE_ASSET__mIuODhMf__"